import React, { useEffect } from 'react';
import Config from 'arbitrip-common/client/utils/Config';

function getStaticTitle() {
    if (Config.is_letstay) {
        return 'Let’Stay';
    }

    if (Config.is_airhaifa) {
        return 'סוגרים מלון דרך אייר חיפה | Air Haifa Stays';
    }

    if (Config.htz) {
        return 'TripZone';
    }

    if (Config.is_elal) {
        return 'הזמנת מלונות בחו"ל, מימוש וצבירת נקודות עם EL AL Travel | אל על';
    }

    if (Config.is_isracard) {
        return 'מלונות בחו"ל - הזמנה במחירים משתלמים ללקוחות ישראכרט | TimeOff';
    }

    return '';
}

const DocumentTitle = ({ title = '', children }) => {
    const resolvedTitle = getStaticTitle() || title;

    useEffect(() => {
        document.title = resolvedTitle;
    }, [resolvedTitle]);

    return React.Children.only(children);
};

export default DocumentTitle;
